import cs from 'classnames';
import type { Program, ProgramTimelineContentObject, Topic } from 'models';
import { usePermissions } from 'permissions';
import { Flex, Text } from 'ui';
import { useGetTypeForIndex } from './hooks';
import { ProgramTopicFilter } from './program-topic-filter';
import { ProgramTopicPost } from './program-topic-post';

type FilterState = {
  sort: string;
  type: string[];
};

type P = {
  filter: FilterState;
  filterPosts: (sort: Partial<FilterState>) => void;
  index: number;
  onSelectPost: (topic: Topic, post: ProgramTimelineContentObject, index: number) => void;
  onSelectTopic: (index: number, oldPostIndex: number) => void;
  posts: ProgramTimelineContentObject[];
  program?: Program;
  selected: boolean;
  selectedIndex: number;
  setFilter: (value: string[]) => void;
  topic: Topic;
};

const ProgramTopic = ({
  filter,
  filterPosts,
  index,
  onSelectPost,
  onSelectTopic,
  posts,
  program,
  selected,
  selectedIndex,
  setFilter,
  topic,
}: P) => {
  const getTypeForIndex = useGetTypeForIndex(selectedIndex);
  const { canSeeFuturePosts } = usePermissions();

  return (
    <>
      <Flex
        className={cs('list-item', 'list-item__header', { 'list-item__header--selected': selected })}
        gap="xs"
        onClick={() => {
          onSelectTopic(index, 0);
        }}
      >
        <Text size="large">{index + 1}</Text>
        <Text className={cs('list-item__value', { 'list-item__value--selected': selected })} size="large">
          {topic.name}
        </Text>
      </Flex>
      {selected ? (
        <>
          {canSeeFuturePosts({ program }) ? (
            <ProgramTopicFilter filter={filter} filterPosts={filterPosts} selected={selected} setFilter={setFilter} />
          ) : null}
          <div className="list-item__content" id={`program_topic-content[${index}]`}>
            {posts.map((post, postIndex) => (
              // eslint-disable-next-line react/jsx-key -- TODO: fix
              <ProgramTopicPost
                last={postIndex === posts.length - 1}
                onClick={() => {
                  onSelectPost(topic, post, postIndex);
                }}
                post={post}
                type={getTypeForIndex(postIndex)}
              />
            ))}
          </div>
        </>
      ) : null}
    </>
  );
};

export default ProgramTopic;
